"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _excluded = ["theme", "className", "title", "logo", "children"];
var shouldRenderTitle = function shouldRenderTitle(title) {
  return !(0, _isNil["default"])(title) && title.trim() !== '';
};
var AppHeader = function AppHeader(_ref, ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    className = _ref.className,
    title = _ref.title,
    logo = _ref.logo,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var defaultClassName = (0, _classnames["default"])("app-header app-header-".concat(theme), className);
  return /*#__PURE__*/_react["default"].createElement("header", (0, _extends2["default"])({
    className: defaultClassName
  }, rest, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-header-logo"
  }, logo), shouldRenderTitle(title) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-header-title"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, title)), children);
};
var AppHeaderForward = /*#__PURE__*/_react["default"].forwardRef(AppHeader);
var _default = exports["default"] = AppHeaderForward;